import { JavaObject } from '../java/lang/JavaObject';
import { LogConsumerList } from '../core/logger/LogConsumerList';
import { Class } from '../java/lang/Class';
import { Logger } from '../core/logger/Logger';

export abstract class Service extends JavaObject {

	/**
	 * Die Instanz des Logger, der von diesem Service genutzt wird
	 */
	protected logger: Logger = new Logger();

	/**
	 * Die Instanz des Consumers von Log-Informationen. In diesem Fall eine einfache ArrayList
	 */
	protected log: LogConsumerList = new LogConsumerList();


	/**
	 * Erstellt einen neuen Service, dessen Logger automatisch in einen ArrayList loggt.
	 */
	protected constructor() {
		super();
		this.logger.addConsumer(this.log);
	}

	/**
	 * Gibt die Logger-Instanz von diesem Service zurück.
	 *
	 * @return die Logger-Instanz.
	 */
	public getLogger(): Logger {
		return this.logger;
	}

	/**
	 * Gibt das Log dieses Services zurück.
	 *
	 * @return das Log dieses Services
	 */
	public getLog(): LogConsumerList {
		return this.log;
	}

	transpilerCanonicalName(): string {
		return 'de.svws_nrw.core.Service';
	}

	isTranspiledInstanceOf(name: string): boolean {
		return ['de.svws_nrw.core.Service'].includes(name);
	}

	public static readonly class = new Class<Service>('de.svws_nrw.core.Service');

}

export function cast_de_svws_nrw_core_Service(obj: unknown): Service {
	return obj as Service;
}
